module.exports = __webpack_public_path__ + "img/figure05.69dce761.png";